import React from 'react';
import { useTheme } from '@mui/material';

export const Wallet = (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryColor },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={42} height={42} fill="none" {...props}>
            <path
                fill={primaryColor}
                d="M8.112 4.597a5.857 5.857 0 0 0-5.858 5.858v21.09a5.857 5.857 0 0 0 5.858 5.858h25.776a5.856 5.856 0 0 0 5.858-5.858V15.142a5.856 5.856 0 0 0-5.858-5.858H10.455c-.644 0-1.171.527-1.171 1.171 0 .645.527 1.172 1.171 1.172h23.433a3.516 3.516 0 0 1 3.515 3.515v16.403a3.516 3.516 0 0 1-3.515 3.514H8.112a3.516 3.516 0 0 1-3.515-3.514v-21.09A3.516 3.516 0 0 1 8.112 6.94h28.12c.644 0 1.17-.527 1.17-1.171 0-.645-.526-1.172-1.17-1.172H8.111Zm22.261 20.504a1.758 1.758 0 1 0 0-3.516 1.758 1.758 0 0 0 0 3.516Z"
            />
        </svg>
    );
};

export default Wallet;
